import { render, staticRenderFns } from "./DashboardLendingByGender.vue?vue&type=template&id=60ff80c4"
import script from "./DashboardLendingByGender.vue?vue&type=script&lang=js"
export * from "./DashboardLendingByGender.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports